<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="会员信息"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
         :get-data-func="getDataFunc"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="企业名称">
            <el-input v-model="params.EnterpriseName" placeholder="请输入企业名称" clearable />
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="params.PersonName" placeholder="请输入联系人" clearable />
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="params.ContactPhone" placeholder="请输入联系电话" clearable />
          </el-form-item>
          
           <el-form-item label="会员等级">
            <el-select v-model="params.PersonGradeid" placeholder="请选择会员等级" clearable>
              <el-option v-for="(i, k) in Grades" :key="k" :label="i.GradeName" :value="i.RecordId"></el-option>
             </el-select>
           </el-form-item>
          

          <el-form-item label="注册时间">
            <el-date-picker
              size="mini"
              v-model.trim="params.RegStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.RegEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>

        </template>
        <template slot="table">
         
          <el-table-column prop="EnterpriseName" label="企业名称" min-width="100px" />
          <el-table-column prop="PersonName" label="联系人" min-width="150px"/>
          
          <el-table-column prop="ContactPhone" label="联系电话" min-width="150px"/>
       
           <el-table-column prop="GradeName" label="会员等级" min-width="100px"/>
           <el-table-column prop="PersonLabel" label="会员标签" min-width="100px"/>
           <el-table-column prop="PersonPoints" label="会员积分" min-width="100px"/>
             <el-table-column prop="PersonBalance" label="会员余额" min-width="100px"/>
                  
           <el-table-column prop="RegisterTime" label="注册时间" min-width="160px"/>
           
     <!--       <el-table-column prop="RegisterTime" label="注册时间">
          <template slot-scope="{row}">     
            {{$commonJs.toDateString(row.RegisterTime)}}
          </template>
        </el-table-column> -->
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/person/personinfo").default,
        grade_api: require("@/api/person/persongrade").default,
        params: {
          EnterpriseName: "",
          PersonName: "",
          ContactPhone: "",
          PersonIdno: "",
          PersonGradeid: null,
          RegStarttime: null,
          RegEndtime: null,
          EndTime: null,
          State: null,
        },
        Grades: [],
      };
    },
   mounted() {
   
  },
    methods: {
      getDataFunc(params) {
      return new Promise((resolve,reject) => {
        resolve({ Data: [{EnterpriseName:"淘店",PersonName:"张三",ContactPhone:"13508776544",GradeName:"白金会员",PersonLabel:"饮品类、高档食品",PersonPoints:"4000",PersonBalance:"0",RegisterTime:"2024-02-24 18:00:02"},{EnterpriseName:"创客咖啡",PersonName:"李四",ContactPhone:"13308770201",GradeName:"黄金会员",PersonLabel:"复购率高",PersonPoints:"20000",PersonBalance:"30000",RegisterTime:"2024-02-23 10:03:23"}]});
      })
     },
    },
  };
  </script>